import React, { useEffect, useRef } from "react";

import useModel from "../../model/Model";
import MapEngine from "./MapEngine";

const Map = () => {
    const mapContainer = useRef(null);
    const model = useModel();

    useEffect(() => {
        // if (window.location.href.includes("craft")) {
            model.mapEngine = new MapEngine(mapContainer.current, model);
        // }
    }, [mapContainer]);

    return <div id="map" ref={mapContainer}></div>;
};

export default Map;
